<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace, isNumber } from '@bd/vue3-utils'
import { Empty } from '../Common/Empty'
import { Table, type TableColumnType } from 'ant-design-vue'
import { GENDER_LABEL } from '@/constant/biz'
import { Tag } from '../Common/Tag'

const [name] = createNamespace('JtZchLandPensionList')

/** 创建读取 land 字段的列配置 */
const createLandColumn = (title: string, field: string, width: number): TableColumnType => ({
  title,
  dataIndex: `land_${field}`,
  width,
  customRender: ({ record }) => record?.land?.[field]
})

export default defineComponent({
  name,
  props: {
    list: {
      type: Array as PropType<ApiFamilyMembers.Item[]>,
      default: () => []
    }
  },
  setup(props) {
    const columns: TableColumnType[] = [
      { title: '姓名', dataIndex: 'userName', width: 150 },
      {
        title: '购买情况',
        dataIndex: 'isBuying',
        width: 100,
        customRender: ({ record }) => {
          const isBuying = !!record?.land
          return <Tag color={isBuying ? 'green' : 'red'}>{isBuying ? '已购买' : '未购买'}</Tag>
        }
      },
      createLandColumn('身份证号码', 'userIdCard', 200),
      {
        title: '性别',
        dataIndex: 'landGender',
        width: 100,
        customRender: ({ record }) => {
          const gender = record?.land?.gender
          return isNumber(gender) ? GENDER_LABEL[gender] : undefined
        }
      },
      createLandColumn('村组', 'village', 150),
      createLandColumn('合村并组前村民小组', 'oldVillage', 200),
      createLandColumn('户籍所在地', 'address', 200),
      createLandColumn('征地时间', 'time', 150)
    ]

    return () => (props.list.length === 0 ? <Empty /> : <Table dataSource={props.list} pagination={false} columns={columns} size='middle' />)
  }
})
</script>
